module.exports = __webpack_public_path__ + "img/thank.1591486e.png";